import { Component, OnInit } from '@angular/core';
import { FileUploader } from 'ng2-file-upload';

import { environment } from './../../../environments/environment';

import { BookService } from './../../services/book.service';

@Component({
  selector: 'app-covers-uploader',
  templateUrl: './covers-uploader.component.html',
  styleUrls: ['./covers-uploader.component.css'],
  providers: [BookService]
})
export class CoversUploaderComponent implements OnInit {
  uploadMode: string = 'drop'; //drop | select
  public statusMap: any = {};

  eans: string[] = [];

  constructor(public bookService: BookService) { }

  ngOnInit() {
    this.uploader.onCompleteAll = () => {

      this.bookService.callSitoImportCoversEndpoint(this.eans).subscribe(res => {
        console.log(res);

        this.eans = [];

        // this.statusMap[item._file.name] = {
        //   success: true,
        //   message: 'copertina caricata'
        // }
      },
      error => {
        console.log(error);
      })
    }
    this.uploader.onCompleteItem = (item: any, response: any, status: any, headers: any) => {
      // console.log("ImageUpload:uploaded:", item, status, response);

      let wo = JSON.parse(response);

      console.log(item._file.name, wo.success);

      if (wo.success) {
        let ean13 = item._file.name.substring(0, item._file.name.indexOf('.'));
        this.eans.push(ean13);
      } else {
        let we;
        switch (wo.err.code) {
          case 'LIMIT_FILE_SIZE':
            we = 'copertina troppo pesante (dimensione massima: 1 Mb)';
            break;
          case 'INVALID_FILE_TYPE':
            we = 'la copertina deve essere un jpeg';
            break;
          case 'INVALID_FILE_NAME':
            we = 'il nome deve essere [EAN13].jpg';
            break;
          default:
            we = 'la copertina non è valida';
        }

        this.statusMap[item._file.name] = {
          success: false,
          err: we
        }
      }

      // console.log(wo);
      // if (wo.success) {
      //   this.parent.operSnackBar(true, 'copertina caricata');
      //   this.coverpath = this.bookService.getBookCoverPath(this.wmodel.ean13);
      // } else {
      //   let we = wo.err.code == 'LIMIT_FILE_SIZE' ? 'copertina troppo pesante (dimensione massima: 1 Mb)' : (wo.err.code == 'INVALID_FILE_TYPE' ? 'la copertina deve essere un jpeg' : wo.err);
      //   this.parent.operSnackBar(false, we);
      // }
      // this.uploader.queue = []
    }
  }

  public uploader: FileUploader = new FileUploader({ url: environment.server.url + '/book/upload-cover' });
  public hasBaseDropZoneOver: boolean = false;
  public hasAnotherDropZoneOver: boolean = false;

  public fileOverBase(e: any): void {
    this.hasBaseDropZoneOver = e;
  }

  public fileOverAnother(e: any): void {
    this.hasAnotherDropZoneOver = e;
  }

  getTitle(): string {
    return "covers";
  }
}



// WEBPACK FOOTER //
// ./src/app/helpers/covers-uploader/covers-uploader.component.ts